import React from "react";
import { Row, Col, Card, CardBody, Table } from "reactstrap";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";

const icons = {
  "Cash Payment": "ri-wallet-3-line",
  "Bank Payment": "ri-bank-line",
  "Card Payment": "ri-bank-card-line",
  "Online Payment": "ri-smartphone-line",
  Expenses: "ri-money-dollar-box-line",
};

const DashBoardView = ({
  data,
  totalPaymentCount,
  totalPaymentAmount,
  topItems,
  topExpCategory,
}) => {
  return (
    <>
      <Row>
        <Col xl={6}>
          <div className="d-flex flex-column h-100">
            <Row>
              {data.map((item, index) => (
                <Col xl={6} md={6} key={index}>
                  <Card className="card-animate overflow-hidden">
                    <div
                      className="position-absolute start-0"
                      style={{ zIndex: "0" }}
                    >
                      <svg
                        version="1.2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 200 120"
                        width="200"
                        height="120"
                      >
                        <path
                          id="Shape 8"
                          style={{ opacity: ".05", fill: "#67b173" }}
                          d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z"
                        />
                      </svg>
                    </div>
                    <CardBody style={{ zIndex: "1" }}>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1 overflow-hidden">
                          <p className="text-uppercase fw-medium text-muted text-truncate mb-3">
                            {item.type}
                          </p>
                          <h4 className="fs-22 fw-bold ff-secondary mb-0">
                            <span className="counter-value">
                              <CountUp
                                start={0}
                                end={item.amount}
                                separator=","
                                prefix="Rs. "
                                decimals={2} // Assuming amount is in a currency format
                                duration={2}
                              />
                            </span>
                          </h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}

              <div className="table-responsive table-card">
                <Table className="table table-centered table-hover align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th className="text-end">Amount</th>
                      <th className="text-center">Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, key) => (
                      <tr key={key}>
                        <td>
                          <div className="d-flex align-items-center">
                            <i
                              className={`${
                                icons[item.type]
                              } text-primary me-2 align-middle`}
                            ></i>
                            <p className="mb-0 fw-bold">{item.type}</p>
                          </div>
                        </td>
                        <td className="text-end">
                          Rs. <NumberCommas number={item.amount} />
                        </td>
                        <td className="text-center">{item.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Row>
          </div>
        </Col>

        <Col xl={6}>
          <Card className="card-height-100">
            <CardBody>
              <div className="mt-4">
                <h5 className="fw-bold mb-3">Top Selling Items:</h5>
                <Table className="table table-centered table-hover align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Image</th>
                      <th className="text-end">Quantity Sold</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topItems.map((item, key) => (
                      <tr key={key}>
                        <td>{item.title}</td>
                        <td>
                          <img
                            src={item.displayImage.getCDNUrl()}
                            alt={item.title}
                            style={{
                              height: "50px",
                              width: "50px",
                              objectFit: "cover",
                            }}
                            className="rounded"
                          />
                        </td>
                        <td className="text-end">{item.quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="mt-4">
                <h5 className="fw-bold mb-3">Top Expense Categories:</h5>
                <Table className="table table-centered table-hover align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th className="text-end">Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topExpCategory.map((item, key) => (
                      <tr key={key}>
                        <td>{item.category}</td>
                        <td className="text-end">
                          Rs. <NumberCommas number={item.totalAmount} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="text-end">
        <h5>
          Total Payment Count:{" "}
          <span className="text-primary">{totalPaymentCount}</span>
        </h5>
        <h5>
          Total Payment Amount:{" "}
          <span className="text-primary">
            <NumberCommas number={totalPaymentAmount} />
          </span>
        </h5>
      </Row>
    </>
  );
};

export default DashBoardView;
